import { render, staticRenderFns } from "./addPropertyModal.vue?vue&type=template&id=3c411bc3"
import script from "./addPropertyModal.vue?vue&type=script&lang=js"
export * from "./addPropertyModal.vue?vue&type=script&lang=js"
import style0 from "./addPropertyModal.vue?vue&type=style&index=0&id=3c411bc3&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c411bc3')) {
      api.createRecord('3c411bc3', component.options)
    } else {
      api.reload('3c411bc3', component.options)
    }
    module.hot.accept("./addPropertyModal.vue?vue&type=template&id=3c411bc3", function () {
      api.rerender('3c411bc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/labelManage/addPropertyModal.vue"
export default component.exports